import { GET_PIPELINES, SET_PIPELINE_LABELS, SET_PIPELINES, SET_SELECTED_PIPELINE } from '../actions/actionTypes';

const initialState = {
  list: [],
  labels: [],
  isLoading: false,
  isLoaded: false,
  selectedPipeline: null,
};

const pipelinesReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PIPELINES:
      return { ...state, isLoading: true };
    case SET_PIPELINES:
      return {
        ...state,
        list: action.pipelines,
        isLoaded: true,
        isLoading: false
      };
    case SET_PIPELINE_LABELS:
      return {
        ...state,
        labels: action.labels || []
      }
    case SET_SELECTED_PIPELINE:
      return {
        ...state,
        selectedPipeline: action.pipeline,
      }
    default:
      return state;
  }
};

export default pipelinesReducer;
